
































import { Component, Vue, Prop } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import Message from '@/util/MessageWorker';
import Loading from '@/util/loading';

@Component({})
export default class BlockItem extends Vue {
  @Prop({ default: () => {} }) private info: any;
  @Prop({ default: () => {} }) private type: string | number;

  private name = '';

  get insertData() {
    return AppModule.insertData;
  }

  get boxUuid () {
    return AppModule.boxUuid;
  }

  private openComponentDialog() {
    this.addBlock();
  }

  private async addComponent() {
    const params = {
      boxUuid: AppModule.boxUuid,
      data: {
        boxData: this.insertData.data,
        key: this.info.key,
        name: this.name
      }
    };
    Loading.open();
    await Message.emit('generator.scene.addComponent', params);
    Loading.close();
    AppModule.SetShowDashboard(false);
  }

  private async addBlock() {
    const params = {
      boxUuid: this.boxUuid,
      data: {
        boxData: this.insertData.data,
        key: this.info.key,
        name: this.name,
        originData: this.info.originData
      }
    };
    AppModule.SetShowDashboard(false);
    Loading.open();
    await Message.emit('generator.scene.addBlock', params);
  }
}
